<div class="ag-number-filter" data-sui-popover-boundary>
  <sui-form-field>
    <label sui-label [attr.for]="uid + '-operator'">
      <fa-icon
        class="ag-number-filter__label-icon"
        [icon]="['fas', 'hashtag']"
        aria-hidden="true"
      ></fa-icon>
      {{ "ag-text-filter.label.operator" | translate }}
    </label>
    <sui-select
      [id]="uid + '-operator'"
      [ngModel]="operator"
      (ngModelChange)="onOperatorChange($event)"
    >
      @for (op of operators; track op) {
        <sui-select-option [value]="op" [label]="operatorLabel(op)">{{
          operatorLabel(op)
        }}</sui-select-option>
      }
    </sui-select>
  </sui-form-field>
  @if (needsValue) {
    <sui-form-field>
      <label sui-label [attr.for]="uid + '-value'">
        {{
          (needsSecondValue
            ? "ag-number-filter.label.from"
            : "ag-text-filter.label.value"
          ) | translate
        }}
      </label>
      <sui-input
        type="number"
        [id]="uid + '-value'"
        [(ngModel)]="value"
        (keydown.enter)="apply()"
      ></sui-input>
    </sui-form-field>
  }
  @if (needsSecondValue) {
    <sui-form-field>
      <label sui-label [attr.for]="uid + '-value-to'">
        {{ "ag-number-filter.label.to" | translate }}
      </label>
      <sui-input
        type="number"
        [id]="uid + '-value-to'"
        [(ngModel)]="valueTo"
        (keydown.enter)="apply()"
      ></sui-input>
    </sui-form-field>
  }
  <div class="ag-number-filter__footer">
    <sui-button
      class="ag-number-filter__cancel"
      size="sm"
      variant="secondary"
      (click)="cancel()"
    >
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button size="sm" variant="secondary" (click)="reset()">
      {{ "ag-date-range-filter.button.reset" | translate }}
    </sui-button>
    <sui-button
      size="sm"
      variant="primary"
      [disabled]="!canApply"
      (click)="apply()"
    >
      {{ "btn.apply" | translate }}
    </sui-button>
  </div>
</div>
